import { GlobalState } from './state/global.state';

export const states = [GlobalState];

export * from './state/global.state';
export * from './action/global.action';
